import bCorpLogo from 'assets/images/skincare/b-corp-logo.png';
import climateLogo from 'assets/images/skincare/climate-logo.png';
import aapiMonthDesktop from 'assets/images/SocialImpact/aapi-month-desktop.jpg';
import aapiMonthMobile from 'assets/images/SocialImpact/aapi-month-mobile.jpg';
import blackMonthDesktop from 'assets/images/SocialImpact/black-month-desktop.jpg';
import blackMonthMobile from 'assets/images/SocialImpact/black-month-mobile.jpg';
import carbonIcon from 'assets/images/SocialImpact/carbon.svg';
import communityTextImageDesktop from 'assets/images/SocialImpact/community-text-image-desktop.jpg';
import emissionsIcon from 'assets/images/SocialImpact/emissions.svg';
import metricTonnesBgDesktop from 'assets/images/SocialImpact/metric-tonnes-background-desktop.jpg';
import metricTonnesBgMobile from 'assets/images/SocialImpact/metric-tonnes-background-mobile.jpg';
import peopleTextImageDesktop from 'assets/images/SocialImpact/people-text-image-desktop.jpg';
import peopleTextImageMobile from 'assets/images/SocialImpact/people-text-image-mobile.jpg';
import planetTextImageDesktop from 'assets/images/SocialImpact/planet-sustainability-desktop.jpg';
import planetTextImageMobile from 'assets/images/SocialImpact/planet-sustainability-mobile.jpg';
import pumpsIcon from 'assets/images/SocialImpact/pumps.svg';
import sheetIcon from 'assets/images/SocialImpact/sheet.svg';
import socialPartnerApex from 'assets/images/SocialImpact/social_partner_apex.png';
import socialPartnerHMI from 'assets/images/SocialImpact/social_partner_hmi.png';
import socialPartnerProspectParkAliance from 'assets/images/SocialImpact/social_partner_prospect_park_alliance.png';
import socialPartnerProvidenceHouse from 'assets/images/SocialImpact/social_partner_providence_house.png';
import socialPartnerRedhawk from 'assets/images/SocialImpact/social_partner_redhawk.png';
import socialPartnerStopAAPIHate from 'assets/images/SocialImpact/social_partner_stop_aapi_hate.png';
import socialPartnerSummertime from 'assets/images/SocialImpact/social_partner_summertime.png';
import socialPartnerTheLoveLand from 'assets/images/SocialImpact/social_partner_the_love_land.png';
import socialPartnerTrevorProject from 'assets/images/SocialImpact/social_partner_trevor.png';
import socialPartnerYoTeCreo from 'assets/images/SocialImpact/social_partner_yo_te_creo.png';
import heroBlockBgDesktop from 'assets/images/SocialImpact/social-hero-background-desktop.jpg';
import heroBlockBgMobile from 'assets/images/SocialImpact/social-hero-background-mobile.jpg';
import tankproofDesktop from 'assets/images/SocialImpact/tankproof-desktop.jpg';
import tankproofMobile from 'assets/images/SocialImpact/tankproof-mobile.jpg';

import getMediaUrl from 'utils/getMediaUrl';

const content = {
  heroBlock: {
    backgroundImages: {
      desktop: heroBlockBgDesktop,
      mobile: heroBlockBgMobile,
    },
    title: 'Collective impact starts here',
    description:
      'We’re disrupting the beauty industry with an inherently sustainable, made-to-order model that creates collective change one individual at a time. Prose is dedicated to uplifting every voice and championing community from the ground up.',
    logos: [
      { src: bCorpLogo, alt: 'b corp logo certificate' },
      { src: climateLogo, alt: 'climate neutral certificate logo' },
    ],
  },
  planetTextImage: {
    id: 'planet',
    subTitle: 'Planet',
    title: 'Leading with sustainability',
    description:
      'As the first and only carbon-neutral custom beauty brand, we’re committed to building a more sustainable future. We do this with our made-to-order model, which creates significantly less waste than typical mass production and supports a more thoughtful supply chain.',
    images: {
      alt: 'River running through a jungle with a product bottle overlayed',
      mobile: planetTextImageMobile,
      desktop: planetTextImageDesktop,
    },
  },
  carbonFootprintBlock: {
    carbon: {
      title: 'Offsetting 100% of our carbon footprint',
      list: [
        {
          alt: 'icon of two leaves surrounded by two arrows in circles',
          icon: carbonIcon,
          title: '15,000+ tonnes of carbon offset',
          description:
            'We strive to cut our carbon emissions year over year. What we cannot reduce internally, we offset through strategically investing in carbon offset projects that promote renewable energy, reforestation, and more.',
        },
      ],
    },
    metricTonnes: {
      images: {
        mobile: metricTonnesBgMobile,
        desktop: metricTonnesBgDesktop,
      },
      title: 'how much is 15,000 metric tonnes exactly?',
      description: "It's enough energy to power 2,919 homes for an entire year.",
    },
    supplyChain: {
      title: 'Building a more efficient supply chain',
      list: [
        {
          alt: 'icon of an arrow going down and another graph line with dots going top',
          icon: emissionsIcon,
          title: '47% reduced emissions per revenue',
          description:
            'Even as our business has grown and our revenue has scaled, we’ve continued to produce and offset the same levels of emissions. Basically, the bigger we get, the more mindful we become.',
        },
        {
          alt: 'icon of two pumps',
          icon: pumpsIcon,
          title: '2,349,597 pumps reduced',
          description:
            'To help minimize plastic production and usage, customers can opt out of receiving pumps after their first order.',
        },
        {
          alt: 'icon of two sheets with a minus icon',
          icon: sheetIcon,
          title: '5,760,000 sheets of paper saved',
          description:
            'After the first order, shipments include only one paper insert linking to a PDF for more environmentally friendly packaging.',
        },
      ],
    },
  },
  certificateBlock: {
    bCorp: {
      title: 'This company meets high standards of social and environmental impact',
      description:
        'Prose prioritizes business outcomes beyond profit — to make a sustainable, positive impact on customers and the planet.',
      icon: bCorpLogo,
      alt: 'b corp logo certificate',
    },
    climateNeutral: {
      title: 'The first and only carbon-neutral custom beauty brand',
      description:
        'Obtained through measuring emissions, reducing value chain carbon emissions, and compensating for last year’s emissions.',
      icon: climateLogo,
      alt: 'climate neutral certificate logo',
    },
  },
  communityTextImage: {
    subTitle: 'Community',
    title: 'Making space for everyone',
    description:
      'We’re doing away with one-size-fits-all beauty standards and creating more inclusive spaces for uplifting the beauty of the individual. To further invest in our community, we prioritize partners that work directly in Brooklyn.',
    images: {
      alt: 'Woman getting her hair washed in a salon wash station bowl.',
      mobile: communityTextImageDesktop,
      desktop: communityTextImageDesktop,
    },
  },
  eventsBlock: {
    title: 'events & series to celebrate what makes us unique',
    list: [
      {
        title: 'AAPI Icons & Stories',
        subTitle: 'aapi month',
        description:
          'Photo series with Vietnamese photographer Cindy Trinh highlighting unique AAPI creatives, activists, and thought leaders.',
        images: {
          alt: 'Woman standing in front of rolls of fabric',
          mobile: aapiMonthMobile,
          desktop: aapiMonthDesktop,
        },
      },
      {
        title: 'Prose x Tankproof',
        subTitle: 'juneteenth',
        description:
          'Swimming lessons hosted with Tankproof and a workshop with Apricot Brown author Dana L. Drucker around Black identity, hair, and self expression.',
        images: {
          alt: 'Man teaching a woman how to swim in a swimming pool',
          mobile: tankproofMobile,
          desktop: tankproofDesktop,
        },
      },
      {
        title: 'Prose x Stylebox',
        subTitle: 'black history month',
        description:
          'Free monthly styling sessions, demos, and educational workshops with Stylebox Salon, a Black-owned hair salon in Brooklyn.',
        images: {
          alt: 'Women at a black hair styling session talking',
          mobile: blackMonthMobile,
          desktop: blackMonthDesktop,
        },
      },
    ],
  },
  peopleTextImage: {
    button: {
      label: 'Join our team',
      link: '/careers',
    },
    subTitle: 'People',
    title: 'Making an impact at home',
    description:
      "We employ over 150 people at our manufacturing facility in Brooklyn's diverse Sunset Park neighborhood. The importance of creating high-paying jobs for residents, stimulating the local economy, and helping to revitalize a longstanding manufacturing hub in NYC is at the heart of our company values.",
    images: {
      alt: 'Man in a chemical lab. Image from Clark Hodgin, The New York Times, Redux',
      mobile: peopleTextImageMobile,
      desktop: peopleTextImageDesktop,
    },
    imageCaption: 'Clark Hodgin, The New York Time​s, Redux',
  },
  reportBlock: {
    title: 'Read the Sustainability and Social Impact Report',
    button: {
      label: 'download the 2023 report',
      href: getMediaUrl('prose-social-impact-report-2023.pdf'),
    },
  },
  productsCarousel: {
    headline: 'More conscious self care for a lighter carbon footprint',
  },
  socialPartnersBlock: {
    title: 'Our local partners',
    content: 'Over $100,000 donated each year',
    dataFrom: 'sponsored-partners',
    partners: [
      {
        name: 'Apex',
        dataClick: 'Apex',
        dataFrom: 'apex-card',
        image: socialPartnerApex,
        description:
          'Apex for Youth empowers underserved Asian and immigrant youth in NYC with mentorship and educational programs for students between 1st and 12th grade.',
        href: 'https://www.apexforyouth.org/',
      },
      {
        name: 'Prospect Park Alliance',
        dataClick: 'Prospect Park Alliance',
        dataFrom: 'prospect-park-card',
        image: socialPartnerProspectParkAliance,
        description:
          'Prose donated to the Alliance, which employs horticulturalists, maintenance workers, ecologists, educators, and others who ensure the day-to-day maintenance of Prospect Park.',
        href: 'https://www.prospectpark.org/',
      },
      {
        name: 'Summertime Gallery',
        dataClick: 'Summertime',
        dataFrom: 'summertime-card',
        image: socialPartnerSummertime,
        description:
          'Prose donated to Summertime Gallery, which connects neurodiverse artists with the Williamsburg community and provides a platform for artists to share their stories with the world.',
        href: 'https://www.summertimegallery.org/',
      },
      {
        name: 'Providence House',
        dataClick: 'Providence House',
        dataFrom: 'providence-house-card',
        image: socialPartnerProvidenceHouse,
        description:
          'Prose supports Providence House with manufacturing job opportunities for Providence House residents, trauma training and education for Prose managers, and bi-monthly donations of shampoo, conditioner, and hygiene products in partnership with LOLA.',

        href: 'https://www.providencehouse.org/',
      },
      {
        name: 'Yo Te Creo',
        dataClick: 'Yo Te Creo',
        dataFrom: 'yotecreo-card',
        image: socialPartnerYoTeCreo,
        description:
          'Prose donated to Yo Te Creo, a non-profit organization working to end violence, harassment, and sexual abuse.',
        href: 'https://www.instagram.com/yotecreovzla/',
      },
      {
        name: 'Hetrick-Martin Institute',
        dataClick: 'HMI',
        dataFrom: 'HMI-card',
        image: socialPartnerHMI,
        description:
          'Prose donated to the Hetrick Martin Institute, which provides community, basic needs, health education, and career services to thousands of LGBTQ youth every year.',
        href: 'https://hmi.org/',
      },
      {
        name: 'Stop AAPI Hate',
        dataClick: 'Stop AAPI Hate',
        dataFrom: 'AAPI-card',
        image: socialPartnerStopAAPIHate,
        description:
          'Prose donated to Stop AAPI Hate, which tracks and responds to incidents of hate, violence, harassment, discrimination, shunning, and child bulling against AAPI people in the US.',
        href: 'https://stopaapihate.org/',
      },
      {
        name: 'The Loveland Foundation',
        dataClick: 'Loveland',
        dataFrom: 'loveland-card',
        image: socialPartnerTheLoveLand,
        description:
          'Prose donated to The Loveland Foundation, which brings opportunity and healing to communities of color, especially Black women and girls, with access to therapy and mental health resources.',
        href: 'https://thelovelandfoundation.org/',
      },
      {
        name: 'The Trevor Project',
        dataClick: 'Trevor',
        dataFrom: 'trevor-card',
        image: socialPartnerTrevorProject,
        description:
          'Prose donated to The Trevor Project, a national non-profit offering counseling resources for LGBTQ youth.',
        href: 'https://www.thetrevorproject.org/',
      },
      {
        name: 'Redhawk Native American Arts Council ',
        dataClick: 'Redhawk',
        dataFrom: 'redhawk-cart',
        image: socialPartnerRedhawk,
        description:
          'Prose donated to Redhawk, an NYC non-profit founded and led by Indigenous artists and educators which provides educational resources and events for Indigenous and non-Indigenous communities in New York.',
        href: 'https://www.redhawkfoundation.org/',
      },
    ],
  },
};

export default content;
